var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "b-btn",
        {
          staticClass: "btn-card-action btn-card-action-danger my-1",
          on: { click: _vm.sendApprovalRequest },
        },
        [_vm._v("Согласование")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }